import request from '@/utils/request'

// 获取城市列表
export function reqCityList(data) {
  return request({
    url: '/admin/city/list',
    method: 'post',
    data
  })
}
// 搜索城市
export function reqSearchCity(data) {
  return request({
    url: '/admin/city/search',
    method: 'post',
    data
  })
}

// 富文本渲染数据
export function reqContents(data) {
  return request({
    url: '/admin/systemContent/findUnique',
    method: 'post',
    data
  })
}

// 富文本更新
export function reqUpdateContents(data) {
  return request({
    url: '/admin/systemContent/update',
    method: 'post',
    data
  })
}
